import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/awtinvestments/public_html/app/components/blog/singlePost.tsx");
